import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSessionStats } from '../contexts/SessionStatsContext';
import { useSessionNavigation } from '../utils/navigation';
import './DashboardHome.css';
import graph from '../assets/images/icons/graph.svg';
import correctIcon from '../assets/images/icons/correct.svg';
import biologyIcon from '../assets/images/icons/biologia.svg';
import chemistryIcon from '../assets/images/icons/chimica.svg';
import physicsIcon from '../assets/images/icons/fisica.svg';

// Map subject names to icons and colors
const subjectConfig = {
  Biologia: {
    icon: biologyIcon,
    id: 'biologia',
  },
  'Chimica e propedeutica biochimica': {
    icon: chemistryIcon,
    id: 'chimica-propedeutica-biochimica',
  },
  Chimica: {
    icon: chemistryIcon,
  
    id: 'chimica',
  },
  Fisica: {
    icon: physicsIcon,
    id: 'fisica',
  },
};

function DashboardHome() {
  const navigate = useNavigate();
  const { subjectStatistics, loading, error } = useSessionStats();
  const { getSubjectUrl } = useSessionNavigation();

  const handleSubjectClick = (subjectId) => {
    navigate(getSubjectUrl(subjectId));
  };

  if (loading) {
    return null; // Skeleton is shown by AdminLayout
  }

  if (error) {
    return (
      <div className='dashboard-home'>
        <div className='dashboard-header'>
          <div className='title-section'>
            <span className='chart-icon'>
              <img src={graph} alt='Graph' className='chart-icon' />
            </span>
            <h1 className='dashboard-title'>Errore nel caricamento</h1>
          </div>
        </div>
        <div className='error-message'>
          <p>
            Si è verificato un errore durante il caricamento dei dati:{' '}
            {error.message}
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className='dashboard-home'>
      <div className='dashboard-header'>
        <div className='title-section'>
          <span className='chart-icon'>
            <img src={graph} alt='Graph' className='chart-icon' />
          </span>
          <h1 className='dashboard-title'>Performance per materia</h1>
        </div>
      </div>

      <div className='subjects-grid'>
        {subjectStatistics.map((subject) => {
          const config = subjectConfig[subject.subject_name] || {
            icon: biologyIcon,
            color: '#6c9ff2',
            id: subject.subject_name.toLowerCase().replace(/\s+/g, '-'),
          };

          return (
            <div key={subject.subject_name} className='subject-card'>
              <div className='home-subject-header'>
                <img
                  src={config.icon}
                  alt={subject.subject_name}
                  className='subject-icon'
                />
                <h2 className='home-subject-name'>{subject.subject_name}</h2>
              </div>

              <div className='performance-section'>
                <div className='home-progress-bar'>
                  <div
                    className='home-progress-fill'
                    style={{
                      width: subject.accuracy <= 6 ? '20px' : `${subject.accuracy}%`,
                      minWidth: '20px'
                    }}
                  ></div>
                </div>

                <div className='performance-stats'>
                  <span className='performance-label'>Risposte corrette</span>
                  <div className='performance-value'>
                    <span className='percentage'>
                      {subject.accuracy.toFixed(2)}%
                    </span>
                    <img
                      src={correctIcon}
                      alt={subject.subject_name}
                      className='subject-icon'
                    />
                  </div>
                </div>
              </div>

              <button
                className='view-questions-btn'
                onClick={() => handleSubjectClick(config.id)}
              >
                Vedi le domande
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default DashboardHome;
